import { GroupEvent } from 'app/types'
import { GroupEventOption, GroupEventOptions } from './group-event-options'

import { useAuth } from 'app/provider/auth'
import { useState } from 'react'
import { Edit, MegaphoneOff, X } from '@tamagui/lucide-icons'

import { DeleteGroupPostModal, GroupEventEditWizard, MuteUsernameModal } from '../../containers'

export interface GroupEventOptionsContainerProps {
  event: GroupEvent
  onAfterDelete?: () => void
}

export const GroupEventOptionsContainer = (props: GroupEventOptionsContainerProps) => {
  const { user } = useAuth()
  const [open, setOpen] = useState(false)
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [muteUsernameModalOpen, setMuteUsernameModalOpen] = useState(false)

  const isCreator = props.event.creator.id === user?.id
  const isGroupOwner = props.event.group.isOwner

  const options = [
    {
      ...(isCreator && {
        label: 'Edit Event',
        description: 'Edit this event',
        icon: <Edit size={24} />,
        onPress: () => {
          setOpen(false)
          setEditModalOpen(true)
        },
      }),
    },
    {
      ...(!isCreator && {
        label: 'Mute username',
        description: 'Hide all posts from this person',
        icon: <MegaphoneOff size={24} />,
        onPress: () => {
          setOpen(false)
          setMuteUsernameModalOpen(true)
        },
      }),
    },
    {
      ...((isCreator || isGroupOwner) && {
        label: 'Delete Event',
        description: 'Delete this event',
        icon: <X size={24} color="red" />,
        color: 'red',
        onPress: () => {
          setOpen(false)
          setDeleteModalOpen(true)
        },
      }),
    },
  ].filter((option) => option.label) as GroupEventOption[]

  return (
    <>
      <GroupEventOptions open={open} setOpen={setOpen} options={options} />
      {!isCreator && (
        <MuteUsernameModal
          groupPostId={props.event.id}
          mutee={props.event.creator}
          open={muteUsernameModalOpen}
          onOpenChange={setMuteUsernameModalOpen}
        />
      )}
      {(isCreator || isGroupOwner) && (
        <DeleteGroupPostModal
          type="event"
          groupId={props.event.group.id}
          userId={props.event.creator.id}
          groupPostId={props.event.id}
          open={deleteModalOpen}
          onOpenChange={setDeleteModalOpen}
          onAfterDelete={props.onAfterDelete}
        />
      )}
      {isCreator && (
        <GroupEventEditWizard
          open={editModalOpen}
          user={user}
          onOpenChange={setEditModalOpen}
          event={props.event}
        />
      )}
    </>
  )
}
